/* eslint-disable react/no-unused-state */
/* eslint-disable import/no-unresolved */
import { bool, func, shape, string } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { actions as transferActions, selectors as transferSelectors } from "reducers/transfer";
import Notification from "pages/_components/Notification";
import PageLoading from "pages/_components/PageLoading";

import ContextMenu from "pages/_components/ContextMenu";
import TransactionTicket from "pages/_components/TransactionTicket";
import { actions as ecomexActions, selectors as ecomexSelectors } from "reducers/ecomex";
import { actions as formActions } from "reducers/form";
import { selectors as frequentDestinationSelectors } from "reducers/frequentDestination";
import { selectors as sessionSelectors } from "reducers/session";
import { actions as transactionsActions, selectors as transactionsSelectors } from "reducers/transactions";
import * as config from "util/config";
import * as i18n from "util/i18n";
import { exportGenericTicketPdfWithSuccessMessage, getGeneralTicketItem } from "util/transaction";
import { actions as ecomexIframeActions } from "reducers/ecomexIframe";
import Button from "pages/_components/Button";
import classNames from "classnames";
import { resizableRoute } from "pages/_components/Resizable";
import EcomexTransactionData from "./EcomexTransactionData";

const ECOMEX_TRANSACTION_V3_LAYOUT_SCOPES = ["ecomexSnackBarConfirmacion", "ecomexTransactionsHis"];

class EcomexTransaction extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        summary: shape({
            debitAccount: string.isRequired,
            creditAccount: string.isRequired,
            amount: string.isRequired,
            currency: string.isRequired,
            reference: string,
        }).isRequired,
        internalTransfer: bool.isRequired,
        isDesktop: bool.isRequired,
        fetching: bool.isRequired,
        idTransaction: string.isRequired,
        fetchingDownloadSolicitud: bool.isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
    };

    state = {
        isModalDisplayed: false,
        showDrawerMobile: false,
        fetchingDownload: false,
    };

    componentDidMount() {
        const { summary, dispatch } = this.props;
        if (!summary?.idTransaction && localStorage.getItem("flow")) {
            dispatch(push(`${JSON.parse(localStorage.getItem("flow"))}`));
        } else {
            dispatch(transactionsActions.getPotentialSignaturesData(summary?.idTransaction));
        }
        if (summary?.idTransactionStatus === "PENDING") {
            dispatch(ecomexActions.ecomexSetShowSnackBar());
        }
    }

    getAccountObject = (account, type) => {
        const { dispatch } = this.props;
        dispatch(transferActions.getAccountInfo(account, type, true));
    };

    getAccountDescription = ({ number, productType, currency }) => {
        if (!number) {
            return "";
        }
        return `${number} ${productType} ${i18n.get(`currency.label.${currency}`)}`;
    };

    generateTicketBody = () => {
        const {
            summary: { idTransactionStatus },
            summary,
        } = this.props;
        const data = [];
        if (
            idTransactionStatus === "FINISHED" ||
            idTransactionStatus === "CANCELLED" ||
            idTransactionStatus === "PROCESSING" ||
            idTransactionStatus === "FAILED"
        ) {
            data.push(getGeneralTicketItem(`transferSummary.date.label`, summary?.creationDate, "datefulltime"));
            data.push(
                getGeneralTicketItem(
                    `transferConfirmation.idTransaction.label`,
                    summary?.idTransaction.substring(0, 8).toUpperCase(),
                    "string",
                ),
            );
            data.push(
                getGeneralTicketItem(`ecomex.transaction.data.requestType`, summary?.transactionData?.requestType),
            );
            data.push(
                getGeneralTicketItem(
                    `ecomex.transaction.data.requestNumber`,
                    summary?.transactionData?.requestIdEcomex,
                ),
            );
            if (summary?.transactionData?.referencedOperation !== "null") {
                data.push(
                    getGeneralTicketItem(
                        `ecomex.transaction.data.referencedOperation`,
                        summary?.transactionData?.referencedOperation,
                    ),
                );
            }
            data.push(
                getGeneralTicketItem(
                    `ecomex.transaction.data.requestAccountNumber`,
                    summary?.transactionData?.requestAccountNumber,
                ),
            );
            data.push(
                getGeneralTicketItem(
                    `ecomex.transaction.data.beneficiaryName`,
                    summary?.transactionData?.beneficiaryName,
                ),
            );
            data.push(getGeneralTicketItem(`ecomex.transaction.data.concept`, summary?.transactionData?.concept));
            data.push(
                getGeneralTicketItem(
                    `ecomex.transaction.data.requestCurrency`,
                    summary?.transactionData?.requestCurrency,
                ),
            );
            data.push(
                getGeneralTicketItem(
                    "ecomex.transaction.data.requestAmount",
                    new Intl.NumberFormat("es-AR", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    }).format(summary?.transactionData?.requestAmount),
                ),
            );
        }
        return data;
    };

    handleDownloadRequestPDF = () => {
        const { dispatch, summary } = this.props;
        const sequence = summary?.transactionData?.sequencePDF;
        const requestNumber = summary?.transactionData?.requestIdEcomex;
        const historic = true;
        dispatch(ecomexIframeActions.downloadEcomexTransaction(sequence, requestNumber, historic));
    };

    handleDownload = async () => {
        const { internalTransfer, dispatch, summary } = this.props;

        this.setState({ fetchingDownload: true });

        const ticketMessage =
            summary?.tadTrx && summary?.idTransactionStatus !== "FAILED"
                ? i18n.get(
                      internalTransfer
                          ? "transfer.TAD.summary.internalTransfer"
                          : "transfer.TAD.summary.thirdPartiesTransfer",
                  )
                : undefined;

        const ticketData = {
            ticketName: i18n.get("menu.ecomex"),
            ticketBody: [...this.generateTicketBody()],
            ticketMessage,
        };

        await exportGenericTicketPdfWithSuccessMessage(ticketData, dispatch, i18n.get("global.download.success"));

        this.setState({ fetchingDownload: false });
    };

    centerContentMobile = () => (
        <div className="title-account-header-multiline-background-blue">
            <h1 className="w-100 m-0 px-2">{i18n.get("menu.ecomex")}</h1>
        </div>
    );

    signTransaction = () => {
        const { dispatch, summary, isDesktop } = this.props;
        const { idActivity } = summary;

        const title = "menu.ecomex";

        const signTransactionData = <EcomexTransactionData signature isDesktop={isDesktop} />;

        dispatch(push("/transactions/sign"));
        dispatch(
            formActions.signTransactionData({
                idTransaction: summary?.idTransaction,
                idActivity,
                idForm: "",
                content: signTransactionData,
                title,
                pendingDispatch: summary?.pendingDispatch,
            }),
        );

        dispatch(
            formActions.signTransactionPreview({
                idActivity,
                idTransaction: summary?.idTransaction,
                idForm: "",
                ticketData: summary,
            }),
        );

        dispatch(
            ecomexActions.loadEcomexTransaction({
                ...summary,
                action: "sign",
            }),
        );
    };

    handleDismiss = () => {
        this.setState({ isModalDisplayed: false });
    };

    rightContentTransactionScheme = (isFinished) => {
        const { isDesktop, summary } = this.props;

        if (isDesktop || isFinished) {
            return <></>;
        }

        return (
            <>
                {summary?.idTransactionStatus !== "CANCELLED" ||
                    (summary?.idTransactionStatus !== "FAILED" && (
                        <ContextMenu
                            isDesktop={isDesktop}
                            color="white"
                            buttonClassName="align-self-center account-dropdown-header-font font-black-alpha ml-2"
                            items={[
                                {
                                    label: "pendingTransaction.info.scheme",
                                    onClick: () => this.setState({ showDrawerMobile: true }),
                                },
                            ]}
                        />
                    ))}
            </>
        );
    };

    buttonsDetailPending = () => {
        const { summary } = this.props;
        const { idTransactionToCancel } = summary;

        const isCancelScheduledTransaction = !!idTransactionToCancel;

        const pendingButtons =
            !isCancelScheduledTransaction && summary?.idActivity !== "ecomex.send.accept.transaction"
                ? [
                      {
                          label: "global.modify",
                          bsStyle: "primary",
                          onClick: () => this.setState({ isModalDisplayed: true }),
                      },
                  ]
                : [];

        return pendingButtons;
    };

    buttonsDetailFinished = () => {
        const { dispatch, embeddedInV3Shell } = this.props;
        const { fetchingDownload } = this.state;
        const buttons = [];

        buttons.push({
            label: "global.download.ticket",
            bsStyle: "outline",
            loading: { fetchingDownload },
            onClick: () => this.handleDownload("pdf"),
        });

        buttons.push({
            label: "global.goToHome",
            bsStyle: "primary",
            onClick: () => dispatch(push(embeddedInV3Shell ? "/v3/dashboard" : "/desktop")),
        });

        return buttons;
    };

    getCuitDescription = (clientUser) => {
        if (clientUser?.cuil !== undefined) {
            return ` ${i18n.get(`transferSummary.cuil.input.label`)} ${clientUser?.cuil}`;
        }
        return ` ${i18n.get(`transferSummary.cuit.input.label`)} ${clientUser?.cuit}`;
    };

    render() {
        const { isDesktop, summary, fetching, fetchingDownloadSolicitud, embeddedInV3Shell } = this.props;
        const { showDrawerMobile, fetchingDownload } = this.state;

        const isFinished = summary?.idTransactionStatus === "FINISHED";
        const isPending = summary?.idTransactionStatus === "PENDING";
        const showBtnDownPdfApp = config.getBoolean("frontend.ecomex.show.operation.mobile");
        const cargando = false;
        return (
            <>
                <PageLoading loading={cargando}>
                    {!embeddedInV3Shell && <Notification scopeToShow="ecomexSnackBarConfirmacion" />}
                    <TransactionTicket
                        embeddedInV3Shell={embeddedInV3Shell}
                        embeddedV3LayoutScopes={ECOMEX_TRANSACTION_V3_LAYOUT_SCOPES}
                        notificationScope="ecomexTransactionsHis"
                        handleClick={this.handleDownload}
                        handleClickMessage="global.download"
                        headerClassName={!isDesktop ? "blue-main-header-mobile blue-main-title-mobile" : ""}
                        centerElement={isDesktop ? undefined : this.centerContentMobile}
                        uniqueDownload={false}
                        rightContent={() => this.rightContentTransactionScheme(isFinished)}
                        hasInlineButtons
                        hideMobileMenu={!isDesktop}
                        summary={summary}
                        buttonsDetail={isPending ? this.buttonsDetailPending() : this.buttonsDetailFinished()}
                        isDesktop={isDesktop}
                        onSignTicket={this.signTransaction}
                        summaryTitle="menu.ecomex"
                        closeMobileDrawer={() => this.setState({ showDrawerMobile: false })}
                        showDrawerMobile={showDrawerMobile}
                        isFetchingExport={fetchingDownload}
                        fetching={fetching}
                        ignoreHomeButton
                        downloadImageWhite={!isDesktop}>
                        <EcomexTransactionData isDesktop={isDesktop} />
                        {(isDesktop || (!isDesktop && showBtnDownPdfApp)) && (
                            <div
                                className={classNames("admin-content-center", {
                                    "mb-3": !isDesktop,
                                })}>
                                <Button
                                    block
                                    label="ecomex.transaction.download.label"
                                    loading={fetchingDownloadSolicitud}
                                    image="images/download.svg"
                                    onClick={() => this.handleDownloadRequestPDF()}
                                    className={classNames("btn-outline btn-download", {
                                        "max-width-btn w-100": isDesktop,
                                    })}
                                    imageStyle="mr-2"
                                />
                            </div>
                        )}
                    </TransactionTicket>
                </PageLoading>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    summary: ecomexSelectors.getSummary(state),
    internalTransfer: transferSelectors.getInternalTransfer(state),
    potentialSignaturesData: transactionsSelectors.getPotentialSignaturesData(state),
    loggedUser: sessionSelectors.getUser(state),
    fetching: transactionsSelectors.getFetching(state),
    idTransaction: transferSelectors.getIdTransaction(state),
    scheduledCancel: transferSelectors.getScheduledCancel(state),
    frequentDestination: frequentDestinationSelectors.getFrequentDestination(state),
    idEnvironment: frequentDestinationSelectors.getEnviromentId(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    fetchingDownloadSolicitud: ecomexSelectors.getFetchingDownload(state),
});

export default connect(mapStateToProps)(resizableRoute(EcomexTransaction));
